// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, PropTypes, Status, Translate } from '@plesk/ui-library';
import Bytes from './Bytes';

const Available = ({ free, total, min, ...props }) => {
    const result = (
        <Translate
            content="Available.format"
            params={{
                free: <Bytes>{free}</Bytes>,
                total: <Bytes>{total}</Bytes>,
            }}
            {...props}
        />
    );

    if (min && free < min) {
        return <Status intent="danger">{result}</Status>;
    }
    return result;
};

Available.propTypes = {
    free: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    min: PropTypes.number,
};

Available.defaultProps = {
    min: null,
};

export default Available;



// WEBPACK FOOTER //
// ./app/repair/Available.js